import { render, staticRenderFns } from "./footerCopyright.vue?vue&type=template&id=77b4923a&scoped=true&lang=pug&"
import script from "./footerCopyright.vue?vue&type=script&lang=ts&"
export * from "./footerCopyright.vue?vue&type=script&lang=ts&"
import style0 from "./footerCopyright.vue?vue&type=style&index=0&id=77b4923a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4923a",
  null
  
)

export default component.exports